import {
    GET_AZURE_THRESHOLD_SUCCESS,
    GET_AZURE_THRESHOLD_FAIL,
    GET_AZURE_THRESHOLD,
    PUT_AZURE_THRESHOLD,
    PUT_AZURE_THRESHOLD_FAIL,
    PUT_AZURE_THRESHOLD_SUCCESS,
    POST_DISABLE_AZURE_THRESHOLD_ALERTS,
    POST_DISABLE_AZURE_THRESHOLD_ALERTS_SUCCESS,
    POST_DISABLE_AZURE_THRESHOLD_ALERTS_FAIL,
    POST_ENABLE_AZURE_THRESHOLD_ALERTS,
    POST_ENABLE_AZURE_THRESHOLD_ALERTS_SUCCESS,
    POST_ENABLE_AZURE_THRESHOLD_ALERTS_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    azure_threshold: [],
    is_azure_threshold_refreshing: false,
};

const AzureThresholds = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_AZURE_THRESHOLD:
            return {
                ...state,
                is_azure_threshold_refreshing: true,
            }

        case GET_AZURE_THRESHOLD_SUCCESS:
            return {
                ...state,
                azure_threshold: action.payload,
                is_azure_threshold_refreshing: false,
            }

        case GET_AZURE_THRESHOLD_FAIL:
            return {
                ...state,
                error: action.payload,
                is_azure_threshold_refreshing: false,
            }

        case POST_ENABLE_AZURE_THRESHOLD_ALERTS:
            return {
                ...state,
                is_azure_threshold_refreshing: true,
            }

        case POST_ENABLE_AZURE_THRESHOLD_ALERTS_FAIL:
            return {
                ...state,
                error: action.payload,
                is_azure_threshold_refreshing: false,
            }

        case POST_ENABLE_AZURE_THRESHOLD_ALERTS_SUCCESS:
            return {
                ...state,
                azure_threshold: action.payload,
                is_azure_threshold_refreshing: false,
            }

        case POST_DISABLE_AZURE_THRESHOLD_ALERTS:
            return {
                ...state,
                is_azure_threshold_refreshing: true,
            }

        case POST_DISABLE_AZURE_THRESHOLD_ALERTS_FAIL:
            return {
                ...state,
                error: action.payload,
                is_azure_threshold_refreshing: false,
            }

        case POST_DISABLE_AZURE_THRESHOLD_ALERTS_SUCCESS:
            return {
                ...state,
                azure_threshold: action.payload,
                is_azure_threshold_refreshing: false,
            }

        case PUT_AZURE_THRESHOLD:
            return {
                ...state,
                is_azure_threshold_refreshing: true,
            }

        case PUT_AZURE_THRESHOLD_SUCCESS:
            Object.keys(state.azure_threshold).forEach(key => {
                if (state.azure_threshold[key].id === action.payload.azure_threshold.id) {
                    state.azure_threshold[key] = action.payload
                }
            })
            return {
                ...state,
                azure_threshold: state.azure_threshold,
                is_azure_threshold_refreshing: false,
            }

        case PUT_AZURE_THRESHOLD_FAIL:
            return {
                ...state,
                is_azure_threshold_refreshing: false,
                error: action.payload,
            }

        default:
            return state
    }
}

export default AzureThresholds;